import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { AppConfig } from '../core/config/config';
import { LocalStorageKeys } from '../core/constants/storage.keys';

@Injectable({
    providedIn: 'root'
})
export class AuthRequestService {
    private doNotRedirectOnErrorUrls: Array<string>;
    private anonymousUrls: Array<string>;

    constructor(private appConfig: AppConfig) {
        this.doNotRedirectOnErrorUrls = this.appConfig.DontGoToErrorPage_RelativeUrls;
        this.anonymousUrls = this.appConfig.AnonymousEndpoints_RelativeUrls;
    }

    public areTokensAvailable(): boolean {
        let accessTokenExpiration = localStorage.getItem(LocalStorageKeys.AccessTokenExpiryKey);
        let refreshTokenExpiration = localStorage.getItem(LocalStorageKeys.RefreshTokenExpiryKey);
        return accessTokenExpiration !== null && refreshTokenExpiration !== null;
    }

    public isAccessTokenExpired(): boolean {
        // Check within 10 seconds of expiry to ensure the cookie doesn't get removed before the request is sent out.
        let accessTokenExpiration = localStorage.getItem(LocalStorageKeys.AccessTokenExpiryKey);
        
        let jwtExpDate = DateTime.fromISO(accessTokenExpiration).minus({seconds: 10}).toUTC();
        let today = DateTime.local().toUTC(); // The server has the expiry dates in utc.
        return jwtExpDate <= today;
    }

    public isRefreshTokenActive(): boolean {
        let refreshExpiration = localStorage.getItem(LocalStorageKeys.RefreshTokenExpiryKey);

        let refreshExpDate = DateTime.fromISO(refreshExpiration).minus({seconds: 10}).toUTC();
        let today = DateTime.local().toUTC(); // The server has the expiry dates in utc.
        return refreshExpDate > today;
    }

    public isAccessTokenRefreshNeeded(): boolean {
        return this.isAccessTokenExpired();
    }

    public isRequestAnonymous(url: string): boolean {
        return this.checkIfUrlExist(url, this.anonymousUrls);
    }

    public bypassErrorRedirection(url: string): boolean {
        return this.checkIfUrlExist(url, this.doNotRedirectOnErrorUrls);
    }

    /*
     *  Note:
     *  new RegExp(address).test(destination) cannot be used in replacement of address === destination 
     *  because the expression will evaulate to true when an endpoint might contain a string in another
     *  endpoint. Example: Pharmacy is in the endpoint PharmacyMangement
     */
    private checkIfUrlExist(requestUrl: string, checkUrls: string[]): boolean {
        let position = requestUrl.indexOf('/api');
    
        // There will always be something before 'api/' in the url otherwise thi
        if(position === 0 || position === -1) {
          throw new Error("The url parameter is invalid.");
        }
    
        let destinationAddress: string = requestUrl.substring(position);
    
        for (let checkAddress of checkUrls) {
          let newCheckAddressParts: string[] = [];
          let destinationAddressParts = destinationAddress.split("/");
    
          // Replace instances of :id with the actual value in the url for a proper comparison using dynamic values
          checkAddress.split("/").forEach((part, index) => {
            if(part === "{id}") {
              newCheckAddressParts.push(destinationAddressParts[index]);
            }
            else {
              newCheckAddressParts.push(part);
            }
          });
    
          let newCheckAddress = newCheckAddressParts.join("/");
    
          if (newCheckAddress === destinationAddress) {
            return true;
          }
        }
    
        return false;
      }
}